import { createApp } from "vue";
import StoreLocator from "@/storeLocator/storeLocator.vue";
import includes from "@/services/storefrontIncludes";
import "@sass/widget.scss";

// initialize app
const app = createApp(StoreLocator);

includes(app);

// mount app
app.mount("#store-locator");
window.__dismissBootLoader?.();
